<template>
  <div>
    <div
      class="grid-domains grid grid-cols-1 md:grid-cols-3 text-sm transform"
      :class="{
        'w-full top-36 gap-4': !small,
        'w-small top-14 gap-2 left-full -translate-x-full hidden md:grid absolute px-4':
          small,
      }"
    >
      <!-- transition-all duration-500 delay-1000 -->
      <component
        :is="domain[`disabled_${dataset}`] ? 'button' : 'router-link'"
        v-for="domain in domainsGrid"
        :to="domain.to"
        :disabled="domain[`disabled_${dataset}`]"
        :key="domain.id"
        class="grid-domain-button relative bg-white rounded-lg focus:outline-none transition-shadow group hover:no-underline hover:text-current text-left border-0"
        :class="{
          'h-16 p-2': small,
          'p-4': !small,
          'bg-opacity-25 cursor-default': domain[`disabled_${dataset}`],
          'shadow-md hover:shadow-xl focus:ring-2 focus:ring-offset-gray-100 focus:ring-secondary hover:ring-2 hover:ring-offset-gray-100 hover:ring-secondary':
            !domain.disabled,
        }"
        @mouseenter.native="showTooltip($event, domain)"
        @mouseleave.native="tooltip.show = false"
      >
        <div
          v-show="!small"
          class="z-20 relative"
          :class="{
            'opacity-25': domain[`disabled_${dataset}`],
          }"
        >
          <h3 class="title font-bold text-lg leading-snug">
            {{ $t(domain.name) }}
          </h3>
          <p class="title text-gray-500 mt-2">
            {{ $t(domain.text) }}
          </p>
        </div>
      </component>
    </div>
    <VTooltip :show="tooltip.show" :target="tooltip.target" class="w-72">
      <div>
        <div class="font-bold mb-2">{{ tooltip.name }}</div>
        <div class="text-gray-500">{{ tooltip.text }}</div>
      </div>
    </VTooltip>
  </div>
</template>

<script>
import gsap from "gsap";
import VTooltip from "@/components/VTooltip";

export default {
  components: {
    VTooltip,
  },
  data() {
    return {
      publicPath: window.data_vis_uri || process.env.BASE_URL,
      tooltip: {
        show: false,
        value: "",
        title: "",
        target: null,
        iso: null,
      },
    };
  },
  props: {
    domains: {
      type: Array,
      default: () => [],
    },
    small: {
      type: Boolean,
      default: false,
    },
    iso: {
      type: String,
      default: "",
    },
  },
  computed: {
    dataset() {
      return this.$route.params.dataset || "girls";
    },
    domainId() {
      return this.$route.params.domainId;
    },
    regionId() {
      return this.$route.params.regionId;
    },
    domainsGrid() {
      return this.domains.map((domain) => ({
        ...domain,
        to: {
          name: this.$route.name,
          params: {
            domainId: domain.id,
            indicatorId: this.getIndicadorFromDomain(domain.id),
            iso: this.iso,
            regionId: this.regionId,
            dataset: this.dataset,
          },
          // query: { dataset: this.dataset },
        },
      }));
    },
  },
  mounted() {
    // this.enter();
  },
  beforeDestroy() {
    // this.leave();
  },
  methods: {
    // returns the first non-disabled indicator for a given domain
    getIndicadorFromDomain(domainId) {
      if (this.domainId === domainId) {
        return this.$route.params.indicatorId;
      }
      return this.domains
        .find((e) => e.id === domainId)
        .indicators.find((e) => !e[`disabled_${this.dataset}`])?.id;
    },
    showTooltip({ target }, domain) {
      this.tooltip.target = target;
      this.tooltip.name = domain.name;
      this.tooltip.text = domain.text;
      this.tooltip.show = this.small;
    },
    enter() {
      gsap.fromTo(
        ".grid-domain-button",
        { y: -50, x: 0, opacity: 0, scale: 1 },
        {
          y: 0,
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 0.3,
          delay: 0.75,
          ease: "power4.out",
          stagger: {
            // wrap advanced options in an object
            each: 0.1,
            from: "end",
            grid: "auto",
            // ease: "power4.out",
            // repeat: -1, // Repeats immediately, not waiting for the other staggered animations to finish
          },
        }
      );
    },
    leave() {
      gsap.fromTo(
        ".grid-domain-button",
        { y: 0, x: 0, opacity: 1, scale: 1 },
        {
          y: -50,
          x: 0,
          opacity: 0,
          scale: 1,
          duration: 0.3,
          ease: "power4.in",
          stagger: {
            // wrap advanced options in an object
            each: 0.1,
            from: "start",
            grid: "auto",
            // ease: "power4.out",
            // repeat: -1, // Repeats immediately, not waiting for the other staggered animations to finish
          },
        }
      );
    },
    shrink() {
      // console.log("shrink");
      const tl = gsap.timeline();
      tl.fromTo(
        ".title",
        {
          opacity: 1,
          y: 0,
        },
        {
          duration: 0.5,
          opacity: 0,
          y: -100,
          ease: "power4.in",
        }
      );

      const icon = 48;
      const padding = 8;
      const gap = 2 * 8;
      const button = padding * 2 + icon;
      const container = button * 3 + gap + 32;

      tl.to(".grid-domain-button", {
        height: button,
        padding,
        duration: 0.5,
      });
      tl.to(
        ".grid-domain-icon",
        {
          height: icon,
          width: icon,
          top: padding,
          right: padding,
          duration: 0.5,
        },
        "<"
      );
      tl.to(".grid-domains", {
        width: container,
        duration: 0.5,
      });
      tl.fromTo(
        ".grid-domains",
        {
          // top: 24,
          left: "50%",
          x: "-50%",
        },
        {
          top: 24,
          left: "100%",
          x: "-100%",
          duration: 0.5,
        }
      );
    },
  },
  watch: {
    // small(val) {
    //   if (val) this.shrink();
    // },
  },
};
</script>

<style>
.grid-domains .router-link-active {
  @apply ring-2 ring-offset-gray-100 ring-secondary hover:ring-secondary;
}
.w-small {
  width: 240px;
}
</style>
